document.addEventListener("DOMContentLoaded", () => {
    let quickAddDrawer = document.querySelector('.thb-cart-form')
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                if (m.addedNodes.length) {
                    BSS_B2B.observer.cartSubject.listenCartCheckout()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }

    let colections = document.querySelector('#ProductGridContainer')
    if (colections) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(async function(m) {
                if (m.addedNodes.length) {
                    const res = await BSS_B2B.storage.productStorage.load();
                    if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                        await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                            ...res,
                        });

                    }
                }
            });
        });
        observer.observe(colections, {
            childList: true
        });
    }

});